import React, { useState } from 'react';
import NavBar from '../Components/NavBar';
import "./Waitlist.css";
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://vfcfuprvvwwflestsagt.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmY2Z1cHJ2dnd3Zmxlc3RzYWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI3Mjg3NDksImV4cCI6MjAyODMwNDc0OX0.qx0UswYWrVW4yjmyeY4RuKtv1fW9kWXJd8wUtdl5RdI";

const supabase = createClient(supabaseUrl, supabaseKey);

const Waitlist = () => {
    const [email, setEmail] = useState('');
    const [addedSuccessfully, setAddedSuccessfully] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleJoinWaitlist = async (event) => {
        event.preventDefault();

        try {
            const { data, error } = await supabase.from('emails').insert([{ email }]);
            if (error) {
                throw error;
            }
            console.log('Email added successfully:', data);
            setAddedSuccessfully(true); // Set state to indicate successful addition
            setEmail(''); // Clear the input box
        } catch (error) {
            console.error('Error adding email:', error.message);
        }
    };

    return (
        <>
            <NavBar />
            <div className="waitlist-wrapper">
                <div className="title-waitlist-wrapper">
                    seamless international shopping!
                </div>
                <div className="title-waitlist-wrapper2">
                    cheaper shipping & simple shopping
                </div>
                <form className="email-stuff" onSubmit={handleJoinWaitlist}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        className="email-input"
                        value={email}
                        onChange={handleEmailChange}
                        required
                    />
                    <button type="submit" className="waitlist-button">JOIN THE WAITLIST</button>
                </form>
                {addedSuccessfully && (
                    <p className="added-successfully">Email added successfully!</p>
                )}
            </div>
        </>
    );
};

export default Waitlist;
